var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 4V9.33333L10.0002 7.33333L12.0002 9.33333V4M13.3335 13.3333C13.6871 13.3333 14.0263 13.1929 14.2763 12.9428C14.5264 12.6928 14.6668 12.3536 14.6668 12V5.33333C14.6668 4.97971 14.5264 4.64057 14.2763 4.39052C14.0263 4.14048 13.6871 4 13.3335 4H8.06683C7.84384 4.00219 7.62386 3.94841 7.42703 3.84359C7.2302 3.73877 7.0628 3.58625 6.94016 3.4L6.40016 2.6C6.27876 2.41565 6.11348 2.26432 5.91916 2.1596C5.72485 2.05488 5.50757 2.00004 5.28683 2H2.66683C2.31321 2 1.97407 2.14048 1.72402 2.39052C1.47397 2.64057 1.3335 2.97971 1.3335 3.33333V12C1.3335 12.3536 1.47397 12.6928 1.72402 12.9428C1.97407 13.1929 2.31321 13.3333 2.66683 13.3333H13.3335Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderBookmark);
export default __webpack_public_path__ + "static/media/folder-bookmark.8a859064.svg";
export { ForwardRef as ReactComponent };